const ss = sessionStorage;

export default {
  setItem (name, val) {
    ss.setItem(name, JSON.stringify(val));
  },
  getItem (name) {
    try {
      return JSON.parse(ss.getItem(name));
    } catch {
      return null;
    }
  },
  removeItem (name) {
    ss.removeItem(name);
  },
  clear () {
    ss.clear();
  }
};
